import { AutogenLayoutSystemHealth } from "./autogen/AutogenLayoutSystemHealth";
import { DataSourceExecutionEvent, DataDisplayEvent, Label, Button } from "@mcleod/components";

export class SystemHealth extends AutogenLayoutSystemHealth {

    sourceSystemHealthBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter = { view: "summary"};
    }

    sourceSystemHealthDetailsBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter = { view: "full"};
    }

    sourceSystemHealthAlertsBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter = { view: "alerts"};
    }
    labelCurrentLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    colorLabels(event: DataDisplayEvent) {
        const label = event.target as Label;

        if (label.text === "normal")
            label.setProps({ text: "Normal", color: "success", backgroundColor: "success.reverse" });
        else if (label.text === "urgent")
            label.setProps({ text: "URGENT", color: "error.reverse", backgroundColor: "error" });
        else if (label.text === "important")
            label.setProps({ text: "Important", color: "error", backgroundColor: "warning.reverse" });
        else if (label.text === "warning")
            label.setProps({ text: "Warning", color: "warning", backgroundColor: "error.reverse" });
    }

    colorButtons(event: DataDisplayEvent) {
        const button = event.target as Button;

        if (button.getDataValue() === "normal")
            button.setProps({ color: "success", backgroundColor: "success" });
        else if (button.getDataValue() === "urgent")
            button.setProps({ color: "error", backgroundColor: "error" });
        else if (button.getDataValue() === "important")
            button.setProps({ color: "warning", backgroundColor: "warning" });
        else if (button.getDataValue() === "warning")
            button.setProps({ color: "caution", backgroundColor: "caution" });
    }

    labelDayLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    labelWeekLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    labelItemCurrentLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    labelItemDayLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    labelItemWeekLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }


    labelAlertLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    labelCurrentAlertLevelStringOnDataDisplay(event: DataDisplayEvent) {
        this.colorLabels(event);
    }

    cellAlertLevelOnDataDisplay(event: DataDisplayEvent) {

    }

    buttonCurrentAlertLevelStringOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonCurrentLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonDayLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonWeekLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonItemCurrentLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonItemDayLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }

    buttonItemWeekLevelOnDataDisplay(event: DataDisplayEvent) {
        this.colorButtons(event);
    }
}
